import React from 'react';

import {
  OrderItem,
  FlexItem,
  FileText,
  AddressText,
  CreatedText,
  CouncilText,
  SecondaryText,
  StatusChipStyled,
  UrgentChipStyled,
  StandardChipStyled
} from './OrdersStyled';

import { 
  getText, 
  getColor, 
  getAddress,
  formatDate,
  getPlanParcel
} from 'utils';

const UrgantChip = ({ urgent }) =>
  urgent ? (
    <UrgentChipStyled>Urgent</UrgentChipStyled>
  ) : (
    <StandardChipStyled>Standard</StandardChipStyled>
  );

const StatusChip = ({ color, text }) => (
  <StatusChipStyled color={color}>{text}</StatusChipStyled>
);

export const OrderListItem = (props) => {
  const handleClick = () => props.onClick(props.id);
  const planParcel = getPlanParcel(props);

  return (
    <OrderItem
      border={props.border}
      onClick={handleClick}
      secondary={props.secondary}
    >
      <FlexItem maxWidth={480} justify={'flex-start'} flex={2}>
        <AddressText>
          {getAddress(props)}{' '}
          {planParcel && <SecondaryText>{planParcel}</SecondaryText>}
        </AddressText>
      </FlexItem>

      <FlexItem paddingLeft={32} maxWidth={200} justify={'flex-start'}>
        <FileText>{props.file_number || '—'}</FileText>
      </FlexItem>

      <FlexItem justify={'flex-start'}>
        <CreatedText>{formatDate(props.created_on)}</CreatedText>
      </FlexItem>

      <FlexItem justify={'flex-start'}>
        <CouncilText>{props.council_id && props.council ? props.council.name : 'N/A'}</CouncilText>
      </FlexItem>

      <FlexItem justify={'flex-start'}>
        <UrgantChip urgent={props.is_urgent} />
      </FlexItem>

      <FlexItem justify={'flex-start'}>
        <StatusChip text={getText(props.status)} color={getColor(props.status)} />
      </FlexItem>

      {props.renderRight && (
        <FlexItem justify={'flex-end'}>{props.renderRight()}</FlexItem>
      )}
    </OrderItem>
  );
};

OrderListItem.defaultProps = {
  onClick: () => null
};

export default OrderListItem;
